<template>
  <div class="w-full h-full grid">
    <el-select
        class="col-span-1"
        value-key="id"
        v-model="value"
        placeholder=""
        filterable
        clearable
        :disabled="readOnly"
    >
      <el-option
          v-for="option in deliveries"
          :key="option.id"
          :label="t(option.name)"
          :value="option.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script lang="ts">
import {defineComponent, ref} from 'vue'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import {useContext} from "@/plugins/context";
import {useI18n} from "vue-i18n";
import {i18nOrderMessages, Order} from "@/models/sales/Order";
import {ElMessage, ElMessageBox} from "element-plus";
import Delivery from "@/models/delivery/Delivery";

export default defineComponent({
  setup() {
    const ctx = useContext();
    const {t} = useI18n({
      messages: {
        en: {...i18nOrderMessages.en},
        ar: {...i18nOrderMessages.ar}
      }
    })

    const order = ref<Order | null>(null);
    const deliveries = ref<Array<Delivery>>(null);
    const value = ref('')
    const previousValue = ref('')
    const label = ref('')

    return {
      ctx,
      t,
      order,
      value,
      previousValue,
      label,
      deliveries
    }
  },
  components: {
  },
  props: ['data', 'readOnly'],
  async mounted() {
    /* @ts-ignore */
    this.order = (this.params?.data || this.$props.data) as Order;
    if (!this.order) {
      return;
    }
    this.value = this.order.invoice.carrierID;
    this.previousValue = this.value;
    try {
      const deliveriesResp = await this.$http.get<Delivery[]>(Delivery.ENDPOINT)
      this.deliveries = deliveriesResp.map((delivery) => Delivery.from(delivery))
    } catch (e) {
      console.log(e)
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (this.previousValue != newVal) {
          this.order.invoice.carrierID = newVal;
          this.onChangeType(newVal)
        }
      }
    },
  },
  methods: {
    onChangeType(event: any) {
      ElMessageBox.confirm(this.t('dialogs.confirmAction'), this.t('dialogs.warning'), {
        confirmButtonText: this.t('dialogs.confirm'),
        cancelButtonText: this.t('dialogs.cancel'),
        type: 'warning'
      })
          .then(() => {
            this.$http
                .post<Order>(
                    `${Order.ENDPOINT}/change-order-carrier/${this.order.id}`,
                    this.order
                )
                .then((resp) => {
                  this.previousValue = this.value;

                  /* eslint-disable vue/no-mutating-props */
                  ElMessage({
                    type: 'success',
                    message: this.t('dialogs.msgUpdated')
                  })
                })
                .catch(() => {
                  this.value = this.previousValue;
                  ElMessage({
                    type: 'error',
                    message: 'error'
                  })
                })
          })
          .catch(() => {
            console.log('cancelled')
            this.value = this.previousValue;
          })
    }
  }
})
</script>
<style>
</style>
